module.exports = __webpack_public_path__ + "media/bootstrap-icons/check2-8d7776a0.svg";